import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {Button} from '@components/common/base/buttons'
import {Input} from '@components/common/base/input'
import {ErrorBoundary} from '@components/common/error-boundary/error-boundary'
import {cn} from '@containers/html-utils'
import {
  RecoveryContext,
  RecoveryStore,
  useRecoveryStore
} from './recovery-store'

export const Recovery = () => {
  const [registerStore] = useState(() => new RecoveryStore())

  return (
    <ErrorBoundary
      silent
      onError={e => logger.error('recovery error ' + e.message)}
    >
      <RecoveryContext.Provider value={registerStore}>
        <RecoveryBase />
      </RecoveryContext.Provider>
    </ErrorBoundary>
  )
}

const RecoveryBase = observer(() => {
  const [state, store] = useRecoveryStore()

  if (state.error) {
    return (
      <div className="login recovery">
        <div className="recovery-page-error">
          <i className="fi-alert" />
          {Lang.msg.recoveryInvalidLink}
        </div>
      </div>
    )
  }

  return (
    <div className="login recovery">
      <div className="login-wnd">
        <div className="login-title">{Lang.msg.recoveryTitle}</div>
        <form className="login-form" autoComplete="off">
          <label className="login-form-field">
            <span className="login-form-label">
              {Lang.msg.recoveryNewPass}:
            </span>
            <Input
              className="max-w-256 mx-auto mb-10"
              type="password"
              autoComplete="off"
              autoFocus
              defaultValue={state.password}
              onChange={e => store.setPassword(e.text)}
              disabled={state.wait}
              onKeyUp={e => store.keyDown(e)}
              placeholder={Lang.msg.recoveryNewPassPl}
            />
          </label>
          <label className="login-form-field">
            <span className="login-form-label">
              {Lang.msg.recoveryRetypePass}:
            </span>
            <Input
              className="max-w-256 mx-auto mb-10"
              type="password"
              disabled={state.wait}
              name="password"
              defaultValue={state.password2}
              onChange={e => store.setPassword2(e.text)}
              onKeyUp={e => store.keyDown(e)}
              placeholder={Lang.msg.recoveryRetypePassPl}
            />
          </label>
          <Button
            className={cn('mx-auto mt-16', state.wait && 'disabled')}
            onClick={store.submit}
          >
            {Lang.msg.recoveryChangePass}
          </Button>
          {state.recoveryError && (
            <div className="login-error">
              <i className="fi-alert" />
              <span>{state.recoveryError}</span>
            </div>
          )}
        </form>
      </div>
    </div>
  )
})
